import React from "react";
import { Outlet } from "react-router-dom";
import StoreHeader from "./StoreHeader";
import StoreFooter from "./StoreFooter";
import MiniCart from "./MiniCart";
import MobileBottomNav from "./MobileBottomNav";
import NewsletterPopup from "./NewsletterPopup";
import JsonLd, { orgSchema, websiteSchema } from "./JsonLd";

export default function StoreLayout() {
  const openSearch = () => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("store:open-search"));
    }
  };

  return (
    <div className="store-shell min-h-screen pb-16 md:pb-0" data-testid="store-layout">
      <JsonLd data={orgSchema()} />
      <JsonLd data={websiteSchema()} />
      <StoreHeader />
      <MiniCart />
      <main>
        <Outlet />
      </main>
      <StoreFooter />
      <MobileBottomNav onSearchClick={openSearch} />
      <NewsletterPopup />
    </div>
  );
}
